module.exports = __webpack_public_path__ + "static/img/share_icon2.5c8c0ac5.png";